{
    "PlaysoundLabel": "Reproduzir som (requer reprodutor de mídia local):",
    "ActivewindowLabel": "Janela ativa (somente navegadores IE\/Firefox com guia única):",
    "AlarmActions_SectionHeader": "Ações de alarme",
    "AlarmActions_SectionPara": "Quando os alarmes são ativados, a linha do relatório e\/ou as estatísticas correspondentes piscarão. Abaixo, você pode escolher ações adicionais que ocorrem para o relatório ativo no momento quando um de seus alarmes começa a ser acionado.",
    "NAME": "AlarmActions"
}